/**
 * Task status API service — points to /api/v1/runner/tasks/.
 *
 * These replace the legacy endpoints at /agentic/data-ingestion/tasks/.
 */
import { apiRequest } from "./client";
import type { SnapshotTaskStatus } from "./data-hub/types";

export type { SnapshotTaskStatus as TaskStatus } from "./data-hub/types";
export type { TaskStep } from "./data-hub/types";

export async function getTaskStatus(taskId: string): Promise<SnapshotTaskStatus> {
  return await apiRequest<SnapshotTaskStatus>({ method: "GET", url: `/runner/tasks/${taskId}` });
}

export async function cancelTask(taskId: string): Promise<{ task_id: string; status: string }> {
  return await apiRequest<{ task_id: string; status: string }>({ method: "POST", url: `/runner/tasks/${taskId}/cancel` });
}

export async function resumeTask(taskId: string): Promise<{ task_id: string; status: string }> {
  return await apiRequest<{ task_id: string; status: string }>({ method: "POST", url: `/runner/tasks/${taskId}/resume` });
}

export async function getTaskStatusBulk(taskIds: string[]): Promise<{ tasks: Record<string, SnapshotTaskStatus> }> {
  return await apiRequest<{ tasks: Record<string, SnapshotTaskStatus> }>({ method: "POST", url: "/runner/tasks/bulk", data: { task_ids: taskIds } });
}
